function employerIdentificationNumberValidator(originalNumber: string): boolean {
  const number = originalNumber.replace(/[^\d]+/g, '');

  if (number == '' || number.length != 14) {
    return false;
  }

  const isTheSameNumber = number.split('').every(digit => digit === number[0]);
  if (isTheSameNumber) {
    return false;
  }

  return true;
}

export default employerIdentificationNumberValidator;
